import { IReduxStore } from "Redux/Store/IReduxStore";

export const getActiveLanguageId = (state: IReduxStore) => {
    for(const id in state.persist.availableLanguages) {
        if(state.persist.availableLanguages[id].key === state.persist.activeLanguage) {
            return id;
        }
    }
    return null;
}